/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { BlockType } from "@vienna/prisma";

export enum SupportedTheme {
  light = "light",
  dark = "dark",
}

// Filter codes you can use in the query
export enum ExploreFilter {
  none = "none",
  text = "text",
  code = "code",
  file = "file",
  image = "image",
  embed = "embed",
}

export const EXPLORE_FILTER_TO_BLOCK_TYPES = {
  [ExploreFilter.none]: [],
  [ExploreFilter.text]: [BlockType.text],
  [ExploreFilter.code]: [BlockType.code],
  [ExploreFilter.file]: [BlockType.file],
  [ExploreFilter.image]: [BlockType.image],
  [ExploreFilter.embed]: [
    BlockType.linkEmbed,
    BlockType.spotifyEmbed,
    BlockType.youtubeEmbed,
    BlockType.twitterEmbed,
    BlockType.instagramEmbed,
  ],
};

// Block Types you can filter by
export const EXPLORE_FILTER_LABEL: { [k in ExploreFilter]: string } = {
  [ExploreFilter.none]: "all",
  [ExploreFilter.text]: "text",
  [ExploreFilter.code]: "code",
  [ExploreFilter.file]: "file",
  [ExploreFilter.image]: "image",
  [ExploreFilter.embed]: "embed",
};

export enum ExploreMode {
  random = "random",
  recent = "recent",
}

export const EXPLORE_MODE_LABEL: { [k in ExploreMode]: string } = {
  [ExploreMode.random]: "Random",
  [ExploreMode.recent]: "Recent",
};

export enum Layer {
  ROOT = 1,
  TOPBAR = 2,
  OVERLAY = 3,
  WIN_LAYER = 99999,
}

export enum TransactionType {
  Create,
  Delete,
  Update,
}
